import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { getPageProps } from "@services/initial-calls";
import { useDomainContext } from "@hooks/useDomainContext";
import MoveMEoutWrapper from "@components/layouts/moveMEoutWrapper";
import MainBanner from "@components/movemeout/mainBanner";

const OffersList = dynamic(() => import("@components/shared/offersList"));
const WhyUs = dynamic(() => import("@components/movemeout/whyUs"));

export default function MoveMEoutHome(): ReactElement {
    const { domain } = useDomainContext();

    return (
        <MoveMEoutWrapper>
            <MainBanner />
            <section>
                <OffersList offers={domain?.defaultOffers} />
            </section>
            <WhyUs />
        </MoveMEoutWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home");
};
